import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/app/surveys/$surveyOrganizationUuid/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/app/surveys/$surveyOrganizationUuid/$languageId',
      params: {
        surveyOrganizationUuid: params.surveyOrganizationUuid,
        languageId: 'en',
      },
    })
  },
})
